import React from 'react';

const PALETTE = ['#4A2C86', '#1E7A4F', '#1F5F7A', '#B07A1F', '#B3261E', '#64748B'];

// Number of distinct non-empty values of `key` in rows.
export const countDistinct = (rows, key) => new Set(rows.map((r) => String(r?.[key] ?? '').trim()).filter((v) => v && v !== '0')).size;

// [{ value, count }] for `key`, most common first.
export const countBy = (rows, key) => {
  const map = new Map();
  rows.forEach((r) => {
    const v = String(r?.[key] ?? '').trim();
    if (!v || v === '0') return;
    map.set(v, (map.get(v) || 0) + 1);
  });
  return [...map.entries()].map(([value, count]) => ({ value, count })).sort((a, b) => b.count - a.count);
};

export const totalFrom = (pagination, fallback) => pagination?.totalRecords ?? pagination?.totalCount ?? pagination?.total ?? fallback;

// Hero tile + small tiles; styles are .cl-summary / .cl-tile* in customerMaster/customerListing.css.
// A tile with an onClick is a button (clicking filters the list); `active` highlights it. The hero tile clears the filter.
// The list APIs return one page at a time, so unless a period is chosen only `total` covers all records.
const SummaryStrip = ({
  label, total, subtitle, tiles, ariaLabel, onHero, heroActive, heroNote,
}) => {
  const Hero = onHero ? 'button' : 'div';
  return (
    <section className="cl-panel cl-summary" aria-label={ariaLabel || label}>
      <Hero
        {...(onHero ? { type: 'button', onClick: onHero, 'aria-pressed': !!heroActive } : {})}
        className={`cl-tile cl-tile-main${onHero ? ' cl-tile-btn' : ''}${heroActive ? ' on' : ''}`}
      >
        <div className="cl-tile-top"><span>{label}</span><span className="cl-mono">{heroNote || 'All records'}</span></div>
        <div className="cl-tile-big"><span className="cl-mono">{Number(total || 0).toLocaleString()}</span>{subtitle && <em>{subtitle}</em>}</div>
      </Hero>
      <div className="cl-tiles">
        {tiles.map((tile, i) => {
          const Tag = tile.onClick ? 'button' : 'div';
          return (
            <Tag
              key={tile.label}
              {...(tile.onClick ? { type: 'button', onClick: tile.onClick, 'aria-pressed': !!tile.active } : {})}
              className={`cl-tile${tile.onClick ? ' cl-tile-btn' : ''}${tile.active ? ' on' : ''}`}
            >
              <div className="cl-tile-label"><i style={{ background: tile.color || PALETTE[i % PALETTE.length] }} />{tile.label}</div>
              <div className="cl-tile-val"><span className="cl-mono">{tile.value}</span><small>{tile.note || 'on this page'}</small></div>
            </Tag>
          );
        })}
      </div>
    </section>
  );
};

export default SummaryStrip;
